import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DatabasesListenerService {

  @Output() databasesListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.databasesListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        }
    );
  }
}
